<div class="confirmation">
  @if (!data?.icon) {
  <div class="icon">
    <span>!</span>
    <img src="assets/icons/Path-33.png" alt="" />
  </div>
  } @if (data?.icon) {
  <mat-icon>{{ data?.icon }}</mat-icon>
  }
  <div class="confirm-message">
    @for (message of data?.messages; track $index) {
    <span [innerHTML]="message"></span> <br /><br />
    }
  </div>
  @if (data?.buttonLabels) {
  <div class="action">
    @if (data?.buttonLabels?.cancel) {
    <button type="button" mat-button mat-dialog-close class="btn-confirm">
      {{ data?.buttonLabels?.cancel }}
    </button>
    } @if (data?.buttonLabels?.confirm) {
    <button mat-button (click)="confirm()" class="cancel" type="button">
      {{ data?.buttonLabels?.confirm }}
    </button>
    }
  </div>
  }
</div>
